var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C30.6267 0 36.6322 2.6812 40.97 7.02997C45.3079 11.3678 48 17.3733 48 24C48 30.6267 45.3079 36.6213 40.97 40.97C36.6322 45.3079 30.6267 48 24 48C17.3733 48 11.3678 45.3079 7.02997 40.97C2.6812 36.6213 0 30.6267 0 24C0 17.3733 2.6812 11.3678 7.02997 7.02997C11.3678 2.6812 17.3733 0 24 0ZM40.2616 7.73842C36.0981 3.57493 30.3542 1.00272 24 1.00272C17.6458 1.00272 11.9019 3.57493 7.73842 7.73842C3.57493 11.9019 1.00272 17.6458 1.00272 24C1.00272 30.3542 3.57493 36.0981 7.73842 40.2616C11.9019 44.4142 17.6458 46.9973 24 46.9973C30.3542 46.9973 36.0981 44.4142 40.2616 40.2616C44.4142 36.0981 46.9973 30.3542 46.9973 24C46.9973 17.6458 44.4142 11.9019 40.2616 7.73842Z",
    fill: "#58B3D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.237 22.7248C15.0408 22.5286 15.0408 22.2125 15.237 22.0163C15.4332 21.8202 15.7492 21.8202 15.9454 22.0163L22.2888 28.3488L32.0544 18.5831C32.2506 18.3869 32.5667 18.3869 32.7629 18.5831C32.9591 18.7793 32.9591 19.0954 32.7629 19.2916L22.6375 29.4169C22.4413 29.6131 22.1253 29.6131 21.9291 29.4169L15.237 22.7248Z",
    fill: "#58B3D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIconBlue);
export default __webpack_public_path__ + "static/media/check_icon_blue.0d0dc7ff2e0ce19535592833073a0c81.svg";
export { ForwardRef as ReactComponent };